'use client';

import React from 'react';
import {AttachesBlockData} from '../../editorjs.types';
import styles from './AttachesPlugin.module.scss';

interface AttachesPluginProps {
  block: {
    data: AttachesBlockData;
  }
}

const AttachesPlugin: React.FC<AttachesPluginProps> = ({block}) => {
  const {data} = block;

  const transformUrl = (url: string): string => {
    if (!url) return '';

    try {
      const newBase = process.env.NEXT_PUBLIC_URL;
      if (!newBase) return url;

      const parsedUrl = new URL(url, newBase); // корректно обрабатывает относительные URL
      const base = new URL(newBase);

      // подмена протокола, хоста и порта
      parsedUrl.protocol = base.protocol;
      parsedUrl.hostname = base.hostname;
      parsedUrl.port = base.port;

      return parsedUrl.toString();
    } catch (error) {
      // если url некорректный — вернуть как есть
      return url;
    }
  };

  const fileUrl = data.file?.url;
  const fileSizeInKB = Math.round(data.file.size / 1024);

  return (
    <div className={styles.attachesContainer}>
      <a
        href={transformUrl(fileUrl)}
        download={`${(data.title && (data.title + data.file.extension && ('.' + data.file.extension))) || data.file.name}`}
        className={styles.attachesLink}
        target={'_blank'}
      >
        {data.title || data.file.name}
      </a>
      {/*<span className={styles.attachesInfo}>*/}
      {/*  ({fileSizeInKB} KB, .{data.file.extension})*/}
      {/*</span>*/}
    </div>
  );
};

export default AttachesPlugin;
